import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import CloseIcon from '@material-ui/icons/Close';
import '../CommonScreens/MessageToast.css';

// Success/error toast for the auth screens (forgot/reset password, first-time
// password change). Kept as a MUI Dialog so show/hide + backdrop behavior is
// unchanged for callers -- only the visible content is now the colored pill
// (green/red, icon, X close) instead of a titled dialog with an Okay button.
// `alertTitle === 'Message'` signals success; anything else (the default
// 'Alert') signals error, matching how callers already set it today.
export default function AlertDialog(props) {
    const handleClose = () => {
        props.closeAlert()
    };

    const isSuccess = props.alertTitle === 'Message';
    const lines = Array.isArray(props.alertMsg) ? props.alertMsg : [props.alertMsg];

    return (
        <Dialog
            open={!!props.showAlert}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{ style: { background: 'transparent', boxShadow: 'none' } }}
        >
            <div className={`message-toast message-toast--${isSuccess ? 'success' : 'error'}`}>
                {isSuccess ? <CheckCircleOutlineIcon className="message-toast__icon" /> : <HighlightOffIcon className="message-toast__icon" />}
                <div className="message-toast__text">
                    {lines.map((line, idx) => <div key={idx}>{line}</div>)}
                </div>
                <CloseIcon className="message-toast__close" onClick={handleClose} />
            </div>
        </Dialog>
    );
}
